import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import type { RemovalRunListItem } from "./useCompetitorLinkRemovalList";
import { RunRow } from "./RunRow";

interface CompetitorLinkRemovalRunsTableProps {
  items: RemovalRunListItem[];
}

export function CompetitorLinkRemovalRunsTable(props: CompetitorLinkRemovalRunsTableProps) {
  return (
    <TableContainer component={Paper} variant="outlined" sx={{ overflowX: "auto" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Статус</TableCell>
            <TableCell>Автоудаление</TableCell>
            <TableCell align="right">Сайтов всего</TableCell>
            <TableCell align="right">Просканировано / ошибок</TableCell>
            <TableCell align="right">Найдено постов / ссылок</TableCell>
            <TableCell align="right">Удалено постов / ссылок</TableCell>
            <TableCell>Автор</TableCell>
            <TableCell>Дата</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.items.map((item) => (
            <RunRow key={item.removalId} item={item} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
